import {
  useState, useEffect, useRef,
} from 'react';
// import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import telemetryActions from '@state/telemetry/actions';
// import { useTranslation } from 'react-i18next';
import devicesApi from '@api/devicesApi';
import telemetryApi from '@api/telemetryApi';

const granularity = [
  { name: 'Detalle', value: 'minute' },
  { name: 'Hour', value: 'hour' },
  // { name: 'Day', value: 'day' },
  // { name: 'Month', value: 'month' },
  { name: 'Month', value: 'day' },
  // { name: 'Year', value: 'year' },
  { name: 'Year', value: 'month' },
];

const granularityNew = [
  { name: 'Detalle', value: 'minute' },
  { name: 'Hour', value: 'hour' },
  { name: 'Day', value: 'day' },
  { name: 'Month', value: 'month' },
  { name: 'Year', value: 'year' },
];

function useConsultGraph() {

  // const dispatch = useDispatch();

  const { device } = useParams();
  const [infoDevice, setInfoDevice] = useState(null);

  const [deviceAllInfo, setDeviceAllInfo] = useState({});
  const [deviceType, setDeviceType] = useState({});
  const [defaultGranularity, setDefaultGranularity] = useState(granularityNew[0].value);
  const [deviceField, setDeviceField] = useState(null);
  const [variableField, setVariableField] = useState([]);
  const [optionVariableField, setOptionVariableField] = useState([]);
  const dateFormat = 'YYYY-MM-DD';
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);

  const today = moment();
  const [modePicker, setModePicker] = useState('');
  const [modePickerFormat, setModePickerFormat] = useState('YYYY-MM-DD');
  const [datePicker, setDatePicker] = useState([today, today]);

  const [seriesGraph, setSeriesGraph] = useState([]);
  const [categoriesGraph, setCategoriesGraph] = useState([]);

  const timerLopping = useRef();

  const changeDate = (e) => {

    if (modePickerFormat === 'YYYY-MM-DD') {

      setDatePicker(moment(datePicker, dateFormat).add(e, 'days'));

    } else if (modePickerFormat === 'YYYY-MM') {

      setDatePicker(moment(datePicker, dateFormat).add(e, 'months'));

    } else {

      setDatePicker(moment(datePicker, dateFormat).add(e, 'years'));

    }

  };

  const changeModePicker = (e) => {

    setDefaultGranularity(e);

    if (e === 'day') {

     setModePicker('day');
     setModePickerFormat('YYYY-MM-DD');

   } else if (e === 'month') {

     setModePicker('month');
     setModePickerFormat('YYYY-MM');

   } else if (e === 'year') {

     setModePicker('year');
     setModePickerFormat('YYYY');

   } else {

     setModePicker('');
     setModePickerFormat('YYYY-MM-DD');

   }

 };

  const loadingFn = async (status) => {

    dispatch(telemetryActions.setLoadingGraphAttribute(status));
    setLoading(status);

  };

  const consultaApi = async () => {

    setDeviceField(null);
    setOptionVariableField([]);
    setVariableField([]);

    const abortC = new AbortController();
    const { signal } = abortC;
    // console.log('useConsultGraph :: infoDevi', infoDevice);

    await devicesApi.getDeviceId({ signal, id: infoDevice }).then((data) => {

      // console.log('useConsultGraph :: data', data);
      // console.log('useConsultGraph name :: data', data.name);

      setDeviceAllInfo(data);
      setInfoDevice(data?.gateway?.mac);

      // console.log('useConsultGraph :: device_types', data.device_types);
      setDeviceType(data.device_types);

      if (data.device_types.length > 0) {

        // console.log('defaultDeviceType ', data.device_types[0].id);
        setDeviceField(data.device_types[0].id);

      } else {

        setDeviceField(null);
        setOptionVariableField([]);
        setVariableField([]);
        loadingFn(false);

      }

    }).catch((error) => {

      console.log('getDeviceId :: error', error.data);

    });

  };

  const consultaApiField = async () => {

    setOptionVariableField([]);
    setVariableField([]);
    loadingFn(true);

    const abortC = new AbortController();
    const { signal } = abortC;

    const data = await telemetryApi.getAllDeviceField({ signal, device_type: deviceField });
    // console.log('consultaApiField :: data', data);

    if (data.length > 0 && deviceField != null) {

      // select variables Field
      const arrSelectVariablesField = data.map((item) => ({
        label: `${item.name} [${item.edge_name}]`,
        value: item.edge_name,
      }));
      setOptionVariableField(arrSelectVariablesField);

      let variablesValid = [];
      if (variableField.length > 0) {

        variablesValid = [...variableField];

      } else {

        variablesValid = [arrSelectVariablesField[0].value];

      }

      setVariableField(variablesValid);

    } else {

      setOptionVariableField([]);
      setVariableField([]);

    }

    loadingFn(false);

  };

  const consultaApiVariableField = async () => {

    if (timerLopping.current) clearTimeout(timerLopping.current);

    // console.log('cambios ', variableField);
    const abortC = new AbortController();
    const { signal } = abortC;

    const auxArryVariable = [];

    optionVariableField.forEach((itemOptionVariable) => {

      variableField.forEach((itemVariableField) => {

        if (itemVariableField === itemOptionVariable.value) {

          auxArryVariable.push(itemOptionVariable);

        }

      });

    });

    if (!auxArryVariable || !auxArryVariable.length) {

      return false;

}

    // console.log('33333333333333 variableField ', variableField);

    let edge_name = variableField.join('&field=');
    edge_name = `&field=${edge_name}`;

    if (!variableField || !variableField.length) {

      setSeriesGraph([]);
      setCategoriesGraph([]);
      return false;

    }

    if (!datePicker || !datePicker.length) {

      setSeriesGraph([]);
      setCategoriesGraph([]);
      return false;

    }

    let startDate = '';
    let endDate = '';
    // datePicker[0].format('YYYY-MM-DD 05:00:00'),
    // datePicker[1].format('YYYY-MM-DD 04:59:59'),

    if (modePicker === 'month') { // YYYY-MM

      const formattedStartDate = datePicker[0].clone()
              .date(1).hour(5).minute(0)
.second(0);

      const formattedEndDate = datePicker[1].clone()
              .date(datePicker[1].daysInMonth()).hour(4).minute(59)
.second(59);

      startDate = formattedStartDate.format('YYYY-MM-DD HH:mm:ss');
      endDate = formattedEndDate.format('YYYY-MM-DD HH:mm:ss');

    } else if (modePicker === 'year') { // YYYY

      startDate = datePicker[0].format('YYYY-01-01 05:00:00');
      endDate = datePicker[1].format('YYYY-12-31 04:59:59');

    } else { // YYYY-MM-DD

      startDate = datePicker[0].format('YYYY-MM-DD 05:00:00');
      endDate = datePicker[1].format('YYYY-MM-DD 04:59:59');

}

    const obj = {
      signal,
      device_type: deviceField,
      edge_name,
      device: infoDevice,
      start_date: startDate,
      end_date: endDate,
      granularity: defaultGranularity,
    };

    await telemetryApi.getGranularityData(obj).then((graphData) => {

      // console.log('consultaApiField :: data', graphData);

      const series = auxArryVariable.map((item, index) => {

        const dataSerieLabel = [];

        graphData.forEach((itemGraphData) => {

          const datgraph = itemGraphData;
          Object.keys(datgraph).forEach((indice) => {

            if (indice.toLowerCase() === item.value.toLowerCase()) {

              dataSerieLabel.push(datgraph[indice].toFixed(3));

            }

          });

        });

        const dataSeries = {
          name: item.label,
          data: dataSerieLabel,
        };

        return dataSeries;

      });

      const categories = graphData.map((item) => item).map((objArry) => `${objArry.date}.000Z`);

      // console.log('consultaApiField :: series', series);
      // console.log('consultaApiField :: categories', categories);

      setSeriesGraph(series);
      setCategoriesGraph(categories);

    }).catch((error) => {

      console.log('consultaApiField: getGranularityData: error', error.data);
      setSeriesGraph([]);
      setCategoriesGraph([]);

    });

    timerLopping.current = setTimeout(
      () => consultaApiVariableField(),
      300000,
    );

    return false;

  };

  const optionsGraph = {
    chart: {
      height: 600,
      type: 'bar',
      toolbar: {
        export: {
            csv: {
                filename: 'GraphBarV',
                columnDelimiter: ',',
                headerCategory: 'category',
                headerValue: 'value',
                dateFormatter: (value) => moment(value).add(5, 'hours').format('YYYY-MM-DDTHH:mm'),
            },
            svg: {
                filename: 'GraphBarV',
            },
            png: {
                filename: 'GraphBarV',
            },
        },
      },
    },
    xaxis: {
      type: 'datetime',
      categories: categoriesGraph.map((value) => moment(value).add(5, 'hours').format('YYYY-MM-DDTHH:mm')),
      labels: {
        formatter: (value) => {

          if (modePicker === 'year') {

            return moment(value).format('YYYY');

          } if (modePicker === 'month') {

                      return moment(value).format('YYYY MMM');

          } if (modePicker === 'day') {

                      return moment(value).format('DD/MM/YY');

          }
            return moment(value).format('DD/MM/YY HH:mm');

        },
      },
    },
    plotOptions: {
      bar: {
        borderRadius: 10,
        dataLabels: {
          position: 'top', // top, center, bottom
        },
      },
    },
    dataLabels: {
      enabled: true,
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#304758'],
      },
    },
    stroke: {
      show: true,
      width: 2,
      colors: ['transparent'],
    },
    tooltip: {
      theme: 'dark',
    },
  };

  useEffect(() => {

    setDeviceField(null);
    setOptionVariableField([]);
    setVariableField([]);

    if (device !== '') {

      setInfoDevice(device);

    } else {

      setDeviceAllInfo({});
      setDeviceType({});
      setOptionVariableField([]);
      setVariableField([]);

    }

  }, [device]);

  useEffect(() => {

    if (infoDevice !== null) {

      consultaApi();

    }

  }, [infoDevice]);

  useEffect(() => {

    if (infoDevice !== null && deviceField !== null && defaultGranularity !== null) {

      consultaApiField();

    }

  }, [deviceField, defaultGranularity, datePicker]);

  useEffect(() => {

    if (variableField !== null) {

      consultaApiVariableField();

    }

  }, [variableField]);

   // Cleanup function to clear the timer when the component unmounts
   useEffect(() => () => {

    if (timerLopping.current !== null) {

      clearTimeout(timerLopping.current);

}

}, []);

  return {
    loading,
    deviceType,
    deviceField,
    granularity,
    granularityNew,
    defaultGranularity,
    datePicker,
    modePicker,
    modePickerFormat,
    changeDate,
    changeModePicker,
    setDatePicker,
    setDeviceField,
    setDefaultGranularity,
    categoriesGraph,
    optionsGraph,
    seriesGraph,
    variableField,
    setVariableField,
    optionVariableField,
    deviceAllInfo,
    setModePicker,
    setModePickerFormat,
  };

}

export default useConsultGraph;
